import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Contact from '../Entity/Contact'
import ContactsEnvironnement from '../Entity/ContactsEnvironnement';

/**
* Class ContactListExterne
* ContactListExterne view component
**/
class ContactListExterne extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = ContactsEnvironnement;

    // Filter list
    const filters = [{
      title: "Nom",
      type: "text",
      name: "nom",
      rowIdx: 1
    },{
      title: "Prénom",
      type: "text",
      name: "prenom",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes contacts domaine</h2>
        <GridFilter title="Filtrer les contacts" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Contacts" ref={"grid" + objectClass.name} path="contactsEnvironnement" objectPath="responsables_contacts/externe" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + ContactsEnvironnement.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + ContactsEnvironnement.name];
    grid.clearFilters();
  }

}
export default ContactListExterne;



// WEBPACK FOOTER //
// ./src/views/Search/ContactListExterne.js